import { render, staticRenderFns } from "./XimuHeader.vue?vue&type=template&id=6177dcae&scoped=true"
import script from "./XimuHeader.vue?vue&type=script&lang=js"
export * from "./XimuHeader.vue?vue&type=script&lang=js"
import style0 from "./XimuHeader.vue?vue&type=style&index=0&id=6177dcae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6177dcae",
  null
  
)

export default component.exports